// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pn-1";
export var stateContainer = "_pn-0";